var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.605 11.01c-.533-2.585-.805-7.942 2.367-8.7 3.965-.946 5.8.355 6.39 2.782.474 1.94.474 3.254.415 3.669 1.282-1.203 4.675-3.207 7.989-1.597 4.142 2.012 2.249 6.51 1.893 7.16-.285.52-1.618 1.558-2.25 2.012 1.125.75 3.315 3.09 3.078 6.45-.296 4.202-4.26 4.97-6.154 4.616-1.515-.283-4.182-2.09-5.326-2.958-.533 1.223-2.13 3.93-4.26 4.97-2.664 1.303-5.208.356-6.983-2.011-1.42-1.893-.316-5.443.414-6.982-1.402.119-4.499-.426-5.682-3.55-1.48-3.906.65-7.16 2.308-7.457 1.657-.294 3.432-.117 5.8 1.6zm5.444 9.408c-3.433-.118-4.143-2.722-4.32-4.379-.178-1.658 2.248-3.906 4.32-3.847 2.07.059 4.437 2.248 3.905 4.911-.533 2.663-2.84 3.314-3.906 3.314z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlice);
export default __webpack_public_path__ + "static/media/ALICE.48ada9e50344e6311e3607257bcf5f04.svg";
export { ForwardRef as ReactComponent };